module.exports = __webpack_public_path__ + "components/country-flag/static/it-77dda5b519b2789c55a4352993ce4fb2.svg";